import React, { useEffect, useState } from 'react';

/** Fixed launch-price deadline: 12.10.2026, 23:59 Warsaw time (CEST, UTC+2). Does not reset. */
const DEADLINE = new Date('2026-10-12T23:59:00+02:00').getTime();
interface OfferState {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}
function getOfferState(): OfferState {
  const remaining = Math.max(0, Math.floor((DEADLINE - Date.now()) / 1000));
  const pad = (n: number) => String(n).padStart(2, '0');
  return {
    days: pad(Math.floor(remaining / 86400)),
    hours: pad(Math.floor(remaining % 86400 / 3600)),
    minutes: pad(Math.floor(remaining % 3600 / 60)),
    seconds: pad(remaining % 60)
  };
}
interface TimeUnitProps {
  value: string;
  label: string;
}
function TimeUnit({
  value,
  label
}: TimeUnitProps) {
  return <div className="flex min-w-[52px] flex-col items-center sm:min-w-[76px]" data-id="element-214" data-mp="29ntjloyr0ubv">
      <span className="font-display text-[36px] font-bold leading-none text-highlight sm:text-6xl" data-id="element-215" data-mp="2eng2adxcj2s2">
        {value}
      </span>
      <span className="mt-2 text-[10px] font-bold tracking-[0.18em] text-white/55" data-id="element-216" data-mp="j61vbhuvfpsv">{label}</span>
    </div>;
}
function Separator() {
  return <span className="flex flex-col items-center gap-2 pt-3 sm:pt-5" aria-hidden="true" data-id="element-217" data-mp="e9usvz1oowfo">
      <span className="h-1.5 w-1.5 rounded-full bg-white/35" data-id="element-218" data-mp="s6q9qdo6fs6a" />
      <span className="h-1.5 w-1.5 rounded-full bg-white/35" data-id="element-219" data-mp="n9hrye6xxq5k" />
    </span>;
}
export function TodayOfferCard() {
  const [offer, setOffer] = useState<OfferState>(getOfferState);
  useEffect(() => {
    const timer = window.setInterval(() => setOffer(getOfferState()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <aside aria-label="Cena na start" className="mt-4 overflow-hidden rounded-2xl bg-foreground px-5 py-8 text-center text-white shadow-offer sm:px-8 sm:py-10" data-id="element-220" data-mp="9ai438r95fag">
      <p className="text-sm font-extrabold tracking-[0.06em] sm:text-base" data-id="element-221" data-mp="3cvxlba3svzhk">
        <span aria-hidden="true" data-id="element-222" data-mp="37xm8cqi7l8v4">⏰</span> CENA NA START{' '}
        <span className="text-highlight" data-id="element-223" data-mp="1bvj0k3q6knef">do 12.10.2026, godz. 23:59</span>
      </p>

      <div className="mt-6 flex items-start justify-center gap-1.5 sm:gap-3" role="timer" aria-live="off" data-id="element-224" data-mp="1btolh61lbpi9">
        <TimeUnit value={offer.days} label="dni" data-id="element-225" data-mp="1ll2i9625qb7p" />
        <Separator data-id="element-226" data-mp="1lnf61zuljfso" />
        <TimeUnit value={offer.hours} label="godz." data-id="element-227" data-mp="1qkfbq9njagj9" />
        <Separator data-id="element-228" data-mp="1qjvw4zlcw48e" />
        <TimeUnit value={offer.minutes} label="min" data-id="element-229" data-mp="1qmi0kqcya3me" />
        <Separator data-id="element-230" data-mp="sxorxqsysdwk" />
        <TimeUnit value={offer.seconds} label="sek." data-id="element-231" data-mp="sy7xs95cbbu8" />
      </div>

      <p className="mt-7 text-sm font-bold text-white sm:text-base" data-id="element-232" data-mp="xuydgvd8g5f4">
        Po tym terminie Pracownia wraca do ceny regularnej.
      </p>
    </aside>;
}